import { render, staticRenderFns } from "./journal.vue?vue&type=template&id=7cd037ab&scoped=true&"
import script from "./journal.vue?vue&type=script&lang=js&"
export * from "./journal.vue?vue&type=script&lang=js&"
import style0 from "./journal.vue?vue&type=style&index=0&id=7cd037ab&lang=less&scoped=true&"
import style1 from "./journal.vue?vue&type=style&index=1&id=7cd037ab&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd037ab",
  null
  
)

export default component.exports